(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('edistradadhluiApp')
        .constant('VERSION', "16.0.0-5-g7b01eb59")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('API_URL', "https://efaktura.dhlecommerce.pl/edistrada2/")
;
})();
